import { CampaignAnalyticsReport } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { themeV2 } from '@features/executive-report/domain/theme-v2';
import { dataFromReport } from '@features/executive-report/subdomains/visitation/slides/visitor-profile';
import { profileStats } from '@features/executive-report/subdomains/visitation/slides/visitor-profile/profile-stats';
import { table } from '@features/executive-report/subdomains/visitation/slides/visitor-profile/table';
import { slideMasters } from '@features/executive-report/utils/slide-masters';
import { Slide } from '@features/powerpoint';
import { metaTableStyle } from './top-states-dmas-locations';
import { cardBackground } from './components/card-background';

type SlideProps = {
  campaignAnalyticsReport: CampaignAnalyticsReport;
};

export const visitorProfileSlide = (props: SlideProps): Slide => {
  const { topData, profileStatsData } = dataFromReport(
    props.campaignAnalyticsReport
  );
  const profileStatsPartial = profileStats({
    data: profileStatsData,
    getCardBackground: () => {
      const shapeProps = cardBackground({ h: 2.92, w: 2.77, x: 7, y: 2.12 });
      return {
        ...shapeProps,
        options: {
          ...shapeProps.options,
          line: undefined,
        },
      };
    },
    profileStatsTextOptions: {
      bold: true,
    },
  });

  return {
    slideMaster: slideMasters.light,
    color: themeV2.colors.metricBlue,
    texts: [
      {
        text: 'The WHO: Visitor Profile',
        options: {
          fontSize: 36,
          bold: true,
          h: 0.75,
          w: 12.67,
          x: 0.33,
          y: 0.38,
        },
      },
      ...(profileStatsPartial.texts ?? []),
    ],
    shapes: profileStatsPartial.shapes ?? [],
    tables: [table(topData, metaTableStyle)],
  };
};
